// react-redux imports
import { MouseEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import SectionTitle from "common/components/styled-components/SectionTitle";
import ImageButton from "common/components/ImageButton";
import ImageButtonContainer from "common/components/styled-components/ImageButtonContainer";

// styled-components imports
import UserInputSection from "../styled-components/UserInputSection";

import { DIET_OPTIONS } from "../constants/nutrition";
import { DietOptions, setDiet } from "./nutritionSlice";

function StepOne() {
  const dispatch = useDispatch();
  const dietSelector = useSelector(
    (state: RootState) => state.calculator.nutrition.diet
  );

  function handleDietSelection(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    const value = e.currentTarget.value as DietOptions;
    if (value === dietSelector) dispatch(setDiet(null));
    else dispatch(setDiet(value));
  }

  return (
    <>
      <SectionTitle>¿Cuál es tu tipo de dieta?</SectionTitle>
      <UserInputSection>
        <ImageButtonContainer>
          {DIET_OPTIONS.map((diet) => (
            <ImageButton
              key={`diet__${diet.value}`}
              value={diet.value}
              label={diet.label}
              url={diet.img}
              selected={dietSelector === diet.value}
              onClick={handleDietSelection}
            />
          ))}
        </ImageButtonContainer>
      </UserInputSection>
    </>
  );
}

export default StepOne;
